import { h } from "preact";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "../../../node_modules/@sgwt-widget/core";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import WorldMapChart from "../../common/components/WorldMapChart";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  AddFpvBlFilter,
  BuildGenericRequest,
  CheckReponseDataForError,
} from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { IFilterItem } from "../../common/generic/generic-types";
import { ITakeClientAndDateProps } from "../../common/utils/types";
import { mapData } from "../utils/helper";

const kpis = "nbi_ytd";
const attributes = "fpv_oeresctry";
const sortOrder = "fpv_oeresctry";

interface IState {
  data: any[][];
}

export class NbiYtdPerOeCountryClass extends ApiBackedComponent<
  ITakeClientAndDateProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: [],
    });
  }

  protected shouldFetchApiData(nextProps: ITakeClientAndDateProps): boolean {
    return this.props.client !== nextProps.client;
  }

  protected renderWithDataReady(): JSX.Element {
    return <WorldMapChart data={this.state.data} />;
  }

  protected async fetchApiData(props: ITakeClientAndDateProps) {
    this.initCorrelationId();
    const headers = props.headers;
    if (
      props.client === undefined ||
      isNaN(parseInt(props.client.bdrCommercialId, 10))
    ) {
      this.setState({
        data: [],
      });
      this.setDataStatus("no-client");
      return;
    }
    this.setDataStatus("loading");
    const attr = new NbiDimensions();
    const filters: IFilterItem[] = [
      {
        attribute: attr.CLIENT_GEN_ID,
        equals: true,
        value: props.client.bdrCommercialId,
      },
    ];
    AddFpvBlFilter(filters, attr.FPV_BL, props.client.fpv_bl);
    const date =
      props.client.value === undefined
        ? undefined
        : new Date(props.client.value);
    const genericRequest = BuildGenericRequest(
      kpis,
      date,
      attributes,
      undefined,
      undefined,
      undefined,
      filters,
      sortOrder,
      sortOrder
    );
    const responseData = await MakeGenericApiCall(
      headers,
      "nbi",
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );
    const errorStatus = CheckReponseDataForError(responseData);
    if (errorStatus) {
      this.setDataStatus(errorStatus);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: [],
      });
    } else {
      const result = mapData(responseData);
      if (result.data.length !== 0) {
        this.setState({
          data: result.data,
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: [],
        });
        this.setDataStatus("no-data");
      }
    }
  }
}

export const NbiYtdPerOeCountry = withWidgetConfiguration(
  NbiYtdPerOeCountryClass
);
